var text_field_default = {
  "root": "_1foa-",
  "text": "_1KX-q",
  "input": "sZDV8",
  "small": "gJ8bB",
  "medium": "pqZne",
  "large": "ptL9F",
  "webview": "rgAbW",
  "endAdornment": "CroJO",
  "shown": "RkRLa",
  "value": "h3lTx",
  "spinner": "VuYNl",
  "spin": "poFJe"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
